import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { createMuiTheme, CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { grey, purple, deepOrange } from '@material-ui/core/colors';
import SelecionarCliente from './pages/SelecionarCliente';
import BoletosList from './pages/BoletosList';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: deepOrange[800],
    },
    secondary: {
      main: purple[800],
    },
    background: {
      default: grey[300],
    },
  },
  status: {
    danger: 'orange',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
      <Switch>
        <Route exact path="/" component={SelecionarCliente} />
        <Route path="/boletos" component={BoletosList} />
      </Switch>
    </ThemeProvider>
  );
}

export default App;
